<template>
  <div id="container">
    <Spinner :show="loading"></Spinner>
    <Header v-if="user"></Header>
    <HeaderGuest v-else></HeaderGuest>
    <section ref="content" id="content" class="section">
      <div v-if="tag" class="card" :class="{blacklisted: tag.isBlacklisted}">
        <div class="card-content">
          <template v-if="tag.isBlacklisted">
            <h2 class="has-text-centered is-size-5">{{ $t("TagHasBeenBlacklisted") }}</h2>
            <hr />
          </template>
          <div class="field has-text-centered">
            <label class="label">{{ $t("TagID") }}</label>
            <div class="control has-icons-left">
              <input class="input" :value="tag.nfcid" type="text" autocomplete="off" readonly>
              <span class="icon is-small is-left">
                <i class="fa fa-tag"></i>
              </span>
            </div>
          </div>
          <div v-if="tag.name" class="field has-text-centered">
            <label class="label">{{ $t("Name") }}</label>
            <div class="control has-icons-left">
              <input class="input" :value="tag.name" type="text" autocomplete="off" readonly>
              <span class="icon is-small is-left">
                <i class="fa fa-tag"></i>
              </span>
            </div>
          </div>
          <div v-if="tag.mobile" class="columns is-mobile is-centered">
            <div class="column is-half">
              <div class="control has-icons-left">
                <div class="select is-fullwidth">
                  <div class="select is-fullwidth">
                    <select ref="callingCode" v-model="tag.callingCode" readonly disabled>
                      <option disabled value="disabled">{{ $t("Country")}}</option>
                      <option v-for="country in countries" :key="country.id" :value="country.callingCode">
                        {{ country.name }} (+{{ country.callingCode }})</option>
                    </select>
                  </div>
                </div>
                <div class="icon is-small is-left">
                  <i class="fa fa-globe"></i>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <div class="control has-icons-left">
                  <input ref="mobile" class="input no-spinner" type="number" :placeholder="$t('Mobile')" v-model="tag.mobile" readonly>
                  <span class="icon is-small is-left">
                    <i class="fa fa-phone"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="field">
          <label class="label has-text-centered">{{ $t("Household") }}</label>
          <div class="control has-icons-left">
            <input class="input" type="text" :value="tag.householdName" readonly>
            <span class="icon is-small is-left">
              <i class="fa fa-user"></i>
            </span>
          </div>
        </div>
        <div class="field">
          <label class="label has-text-centered">{{ $t("SignupDate") }}</label>
          <div class="control has-icons-left">
            <input class="input" type="text" :value="tag.signupDate ? new Date(tag.signupDate).toLocaleDateString() : ''" readonly>
            <span class="icon is-small is-left">
              <i class="fa fa-calendar"></i>
            </span>
          </div>
        </div>
        <div class="field">
          <label class="label has-text-centered">{{ $t("RegisteredBy") }}</label>
          <div class="control has-icons-left">
            <input class="input" type="text" :value="tag.createdBy ? tag.createdBy : ''" readonly>
            <span class="icon is-small is-left">
              <i class="fa fa-user"></i>
            </span>
          </div>
        </div>
        <div v-if="tag.lastUsage" class="field">
          <label class="label has-text-centered">{{ $t("LastUsage") }}</label>
          <div class="control has-icons-left">
            <input class="input" type="text" :value="tag.lastUsage ? new Date(tag.lastUsage).toLocaleDateString() : ''" readonly>
            <span class="icon is-small is-left">
              <i class="fa fa-calendar"></i>
            </span>
          </div>
        </div>
        <div v-if="tag.waterSystemId" class="columns is-mobile is-centered">
        <div class="column is-full">
          <label class="label has-text-centered">{{ $t("WaterSystem") }}</label>
          <div class="control has-icons-left">
            <div class="select is-fullwidth">
              <div class="select is-fullwidth">
                <select ref="waterSystemID" v-model="tag.waterSystemId" readonly disabled>
                  <option disabled value="disabled">{{ $t("WaterSystem")}}</option>
                  <option v-for="waterSystem in this.waterSystems" :key="waterSystem.waterSystemID" :value="waterSystem.waterSystemID">{{ waterSystem.name }}</option>
                </select>
              </div>
            </div>
            <div class="icon is-small is-left">
              <i class="fa fa-tint"></i>
            </div>
          </div>
        </div>
      </div>
      <footer v-if="user">
        <div class="columns is-mobile has-text-centered">
            <div class="column is-half">
                <a v-if="!tag.isBlacklisted" @click="$router.push(`/tag/topup/${tag.nfcid}`)" class="button is-primary is-fullwidth">
                    <span class="icon">
                        <i class="fa fa-arrow-up"></i>
                    </span>
                    <span>{{ $t("Topup") }}</span>
                </a>
            </div>
            <div class="column is-half">
                <a @click="$router.push(`/tag/transactions/${tag.nfcid}`)" class="button is-info is-fullwidth">
                    <span class="icon">
                        <i class="fa fa-history"></i>
                    </span>
                    <span>{{ $t("Transactions") }}</span>
                </a>
            </div>
          </div>
        </footer>
      </div>
      <div v-if="!tag">
        <h4 class="is-size-4 has-text-centered" v-if="!tag">{{ $t("ErrorTagNotFound") }}</h4>
        <br>
        <div v-if="hasPermission('Household', 'Edit')" class="columns is-mobile is-centered">
        <div class="column is-two-thirds has-text-centered">
          <a @click="$router.push('/households/register')" class="button is-primary is-fullwidth">
            <span class="icon">
              <i class="fa fa-home"></i>
            </span>
            <span>{{ $t("RegisterHousehold") }}</span>
        </a>
        </div>
      </div>
      <div v-if="hasPermission('Household', 'Edit')" class="columns is-mobile is-centered">
        <div class="column is-two-thirds has-text-centered">
          <a @click="$router.push('/households/search')" class="button is-primary is-fullwidth">
            <span>{{ $t("AddTagToExistingHousehold") }}</span>
        </a>
        </div>
      </div> 
      </div>
      <div v-if="hasPermission('Household', 'Edit') && tag" class="columns is-mobile is-centered">
        <div class="column is-half has-text-centered">
          <a @click="$router.push({name: 'Household', params: {_householdId: tag.householdID}})" class="button is-primary is-fullwidth">
            <span class="icon">
              <i class="fa fa-home"></i>
            </span>
            <span>{{ $t("EditHousehold") }}</span>
        </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import HeaderGuest from "@/components/HeaderGuest.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "Tag",
  components: {
    Header,
    HeaderGuest,
    Spinner
  },
  props: {
    _nfcId: String
  },
  data()
  {
    return {
      tag: null
    }
  },
  mounted: async function()
  {
    await this.getWaterSystems();

    try
    {
        const response = await this.$http.get(`/Tags/Tag/${this._nfcId.toUpperCase()}`);
        this.tag = response.data.tag;
    }

    catch(error)
    {

    }
  }
};
</script>
